module.exports = __webpack_public_path__ + "static/img/brain.22aba10.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/Header/assets/img/brain.png
// module id = SV4L
// module chunks = 34